import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetEmbeddedSelector = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (payload: { id: string; selector: string }) => dispatch({ type: 'SET_EMBEDDED_SELECTOR', payload }),
    [dispatch],
  );
};
